// Editorial machine corrections only. No professional, clinical or release approval.
// Apply corrections only to the exact reviewed English and previous machine wording.
// English-source drift falls back to current English rather than known-bad old text.
// Professional overrides are applied afterwards by the calling resolver.
import patches from './journeyExplanationSafetyCorrections.json' with { type: 'json' };
import { JOURNEY_BATCH3_EXPLANATIONS } from './journeyBatch3Explanations.js';
import { JOURNEY_BATCH5_EXPLANATIONS } from './journeyBatch5Explanations.js';
import { JOURNEY_BATCH6_EXPLANATIONS } from './journeyBatch6Explanations.js';
import { JOURNEY_BATCH7_EXPLANATIONS } from './journeyBatch7Explanations.js';

const sources = {
  outpatients: JOURNEY_BATCH3_EXPLANATIONS.outpatients,
  respiratory: JOURNEY_BATCH5_EXPLANATIONS.respiratory,
  'discharge-recovery': JOURNEY_BATCH6_EXPLANATIONS['discharge-recovery'],
  paediatrics: JOURNEY_BATCH7_EXPLANATIONS.paediatrics,
  'mental-health': JOURNEY_BATCH7_EXPLANATIONS['mental-health'],
};

const fieldValue = (stage, path) => {
  const parts = path.split('.');
  if (parts.length === 1) return stage?.[parts[0]];
  if (parts.length === 3 && parts[0] === 'nextSteps')
    return stage?.nextSteps?.find(step => step.id === parts[1])?.[parts[2]];
  return undefined;
};

export function applyPinnedStageCorrections(base, source, corrections = {}) {
  if (!base || !source) return base;
  let result = base;
  for (const [path, patch] of Object.entries(corrections)) {
    if (!patch || typeof patch.english !== 'string' || !patch.english.trim()
      || typeof patch.previous !== 'string' || !patch.previous.trim()
      || typeof patch.replacement !== 'string' || !patch.replacement.trim()
      || fieldValue(base, path) !== patch.previous) continue;
    const currentEnglish = fieldValue(source, path);
    if (typeof currentEnglish !== 'string' || !currentEnglish.trim()) continue;
    const text = currentEnglish === patch.english ? patch.replacement : currentEnglish;
    const parts = path.split('.');
    if (parts.length === 1 && ['whatHappens', 'whyItMayHappen', 'whatTeamIsDoing', 'variationNote'].includes(parts[0])) {
      result = { ...result, [parts[0]]: text };
    } else if (parts.length === 3 && parts[0] === 'nextSteps'
      && ['title', 'description', 'when'].includes(parts[2])) {
      result = { ...result, nextSteps: (result.nextSteps || []).map(step =>
        step.id === parts[1] ? { ...step, [parts[2]]: text } : step) };
    }
  }
  return result;
}

export function applyJourneyExplanationSafetyCorrections(language, journeyId, stageId, base) {
  const code = String(language || '').toLowerCase().split('-')[0];
  const id = String(journeyId || '').replace(/^generic-/, '');
  const stage = sources[id]?.[stageId];
  return applyPinnedStageCorrections(base, stage?.explanation || stage,
    patches.locales?.[code]?.[id]?.[stageId]);
}
